import { takeEvery, call, put, select, all } from 'redux-saga/effects';
import {
  updateList,
  sendRequest,
  selectQueryParams,
  initState
} from '../../../../../common/reducers/_list/reducer';
import {
  requestInProcess,
  requestFinished,
  setCodeResponse,
  initState as initRequestStatusState
} from '../../../../../common/reducers/_requestStatus/reducer';
import {
  setPagination,
  initState as initPaginationState
} from '../../../../../common/reducers/_pagination/reducer';
import { timeoutCall } from '../../../../../utils/sagaHalper';
import TasksService from '../../../services/TasksService';
import { insertUpdateItems as insertUpdateObjectCollectionItems } from '../../../../../common/reducers/objectCollection/reducer';

function* getCommentLists(reducerName) {
  const queryParams = yield select(selectQueryParams, reducerName);
  yield put(requestInProcess(reducerName));
  try {
    const result = yield call(
      timeoutCall,
      TasksService.getTasksList,
      queryParams
    );
    if (result.response) {
      yield put(setCodeResponse(reducerName, result.response.status));
      if (result.response.status) {
        yield put(setPagination(reducerName, result.destructData.pagination));
        yield put(
          updateList(reducerName, {
            itemsById: result.destructData.tasksById,
            itemsIds: result.destructData.tasksIds
          })
        );
        yield put(
          insertUpdateObjectCollectionItems(
            'tasksModule.collections.tasksCollection',
            result.destructData.tasksById
          )
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName));
}

function* initStates(reducerName) {
  yield put(initRequestStatusState(reducerName));
  yield put(initPaginationState(reducerName));
}

export default function* createSaga(reducerName) {
  yield all([
    takeEvery(sendRequest(reducerName).type, getCommentLists, reducerName),
    takeEvery(initState(reducerName).type, initStates, reducerName)
  ]);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/dynamic/tasksList/saga.js